import { useModelsStore } from "../stores/ConfigStore";
import { mainAxios as axios } from "./axios";
//#region Emails
export const getAgents = async () => {
  let response = await axios.get(`/ai-agents`);

  if (response.data.state) {
    useModelsStore.getState().setAgents(response.data.models_list);
  }
  return response;
};

export const findAgent = async (id) => {
  return axios.get(`/ai-agents/${id}`);
};

export const createAgent = async ({
  name,
  description,
  website_url,
  first_name,
  last_name,
  linkedin_integration_id,
  sharing,
  tags_ids,
  folder_id,
  value_propositions,
  spoken_language,
  targets,
  rules,
  ...data
}) => {
  return axios.post(`/ai-agents`, {
    name: name,
    description: description,
    website_url: website_url,
    first_name: first_name,
    last_name: last_name,
    linkedin_integration_id: linkedin_integration_id,
    sharing: sharing,
    tags_ids: tags_ids,
    folder_id: folder_id,
    value_propositions: value_propositions,
    targets: targets,
    rules: rules,
    spoken_language,
    ...data,
  });
};

export const editAgent = async ({ id, data }) => {
  return axios.put(`/ai-agents/${id}`, {
    ...data,
  });
};

export const deleteAgent = async ({ id }) => {
  return axios.delete(`/ai-agents/${id}`);
};

export const generateAgentBrief = async ({
  id,
  activity_description,
  website_url,
}) => {
  if (id) {
    return axios.post(`/ai-agents/${id}/generate-brief`, {
      activity_description,
      website_url,
    });
  }
  return axios.post(`/ai-agents/generate-brief`, {
    activity_description,
    website_url,
  });
};

export const generateWorkflowWithAgent = async (data) => {
  return axios.post(`/workflows/ai-agent`, data);
};

export const getWorkflowAiJob = async (job_uniqid) => {
  return axios.get(`/workflows/ai-agent/jobs/${job_uniqid}`);
};
